import React, {Component} from 'react';
import {createJiraConfig, getJiraConfig} from '../../services/jiraService';
import ErrorAlert from "../../components/ErrorAlert";
import SectionCard from "../../patterns/SectionCard";
import FormDialog from "../../patterns/FormDialog";
import TextInput from "../../patterns/form/TextInput";
import Banner from "../../patterns/Banner";
import Toast from "../../patterns/Toast";
import styles from './OrgPanel.module.css';

export default class JiraConfig extends Component {
    constructor(props) {
        super(props);
        this.state = {
            jiraConfig: null,

            showConfigureModal: false,
            configureBusy: false,
            configureJiraError: null,

            newJiraDetails: null,

            persistentErrorMessage: null,
            toast: null,
        }
    }

    async componentDidMount() {
        try {
            const jiraConfigResponse = await getJiraConfig(this.props.org.id);
            this.setState({
                jiraConfig: jiraConfigResponse.config.length ? jiraConfigResponse.config[0] : {}
            });
        } catch (error) {
            this.setState({
                persistentErrorMessage: `Problem getting Jira Config: ${error.toString()}`
            });
        }
    }

    configureJiraClicked = () => {
        this.setState({
            showConfigureModal: true,
            newJiraDetails: {...this.state.jiraConfig}
        });
    }

    cancelConfigureJira = () => {
        this.setState({showConfigureModal: false, newJiraDetails: null, configureJiraError: null});
    }

    jiraProjectKeyChanged = (event) => {
        this.setState({newJiraDetails: {...this.state.newJiraDetails, projectKey: event.target.value}});
    }

    jiraHostChanged = (event) => {
        this.setState({newJiraDetails: {...this.state.newJiraDetails, host: event.target.value}});
    }

    jiraUsernameChanged = (event) => {
        this.setState({newJiraDetails: {...this.state.newJiraDetails, username: event.target.value}});
    }

    jiraPasswordChanged = (event) => {
        this.setState({newJiraDetails: {...this.state.newJiraDetails, password: event.target.value}});
    }

    configureJira = async () => {
        this.setState({configureBusy: true});
        try {
            const {projectKey, host, username, password} = this.state.newJiraDetails;
            await createJiraConfig(this.props.org.id, projectKey, host, username, password);
            this.setState({
                showConfigureModal: false,
                jiraConfig: this.state.newJiraDetails,
                newJiraDetails: null,
                configureBusy: false,
                toast: {message: 'Jira configured'}
            })
        } catch (e) {
            const message = e.response?.data?.error || `Problem configuring Jira: ${e.toString()}`;
            this.setState({configureJiraError: message, configureBusy: false});
        }
    }

    dismissToast = () => this.setState({toast: null});

    render() {
        const {jiraConfig, showConfigureModal, newJiraDetails, configureBusy, configureJiraError,
            persistentErrorMessage, toast} = this.state;

        const fieldsMissing = !newJiraDetails || !newJiraDetails.projectKey || !newJiraDetails.host
            || !newJiraDetails.username || !newJiraDetails.password;

        return (
            <div>
                <SectionCard title="Jira">
                    {!jiraConfig && !persistentErrorMessage && <p className={styles.loading}>Loading Jira config…</p>}
                    <ErrorAlert message={persistentErrorMessage} delay={0}/>
                    {jiraConfig && (
                        <div>
                            {jiraConfig.host ? (
                                <ul className={styles.keyValue}>
                                    <li className={styles.keyValueRow}>
                                        <span className={styles.keyValueKey}>Project key</span>
                                        <span className={styles.keyValueValue}>{jiraConfig.projectKey}</span>
                                    </li>
                                    <li className={styles.keyValueRow}>
                                        <span className={styles.keyValueKey}>Host</span>
                                        <span className={styles.keyValueValue}>{jiraConfig.host}</span>
                                    </li>
                                </ul>
                            ) : <p className={styles.loading}>Jira isn't configured for this org yet.</p>}
                            <button type="button" className={styles.addButton} disabled={this.props.disabled}
                                    onClick={this.configureJiraClicked}>
                                Configure Jira
                            </button>
                        </div>
                    )}
                </SectionCard>

                <FormDialog
                    open={showConfigureModal}
                    title="Configure Jira"
                    onCancel={this.cancelConfigureJira}
                    onSubmit={this.configureJira}
                    submitLabel="Save"
                    submitDisabled={fieldsMissing}
                    busy={configureBusy}
                    wide
                >
                    {(firstFieldRef) => (
                        <>
                            <Banner tone="info">Your Jira project must have 'Story' and 'Subtask' issue types.</Banner>
                            {configureJiraError && <ErrorAlert message={configureJiraError} delay={0}/>}
                            <TextInput
                                ref={firstFieldRef}
                                id="jira-project-key"
                                label="Project key"
                                placeholder="Jira project key"
                                value={newJiraDetails?.projectKey || ''}
                                onChange={this.jiraProjectKeyChanged}
                            />
                            <TextInput
                                id="jira-host"
                                label="Host"
                                placeholder="e.g. https://myco.atlassian.net"
                                value={newJiraDetails?.host || ''}
                                onChange={this.jiraHostChanged}
                            />
                            <TextInput
                                id="jira-username"
                                label="API user"
                                placeholder="e.g. ovalview@myco.net"
                                value={newJiraDetails?.username || ''}
                                onChange={this.jiraUsernameChanged}
                            />
                            <TextInput
                                id="jira-password"
                                label="API key"
                                type="password"
                                placeholder="User API key"
                                value={newJiraDetails?.password || ''}
                                onChange={this.jiraPasswordChanged}
                            />
                        </>
                    )}
                </FormDialog>

                {toast && <Toast message={toast.message} onDismiss={this.dismissToast}/>}
            </div>
        );
    }
}
